// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1FuWV","colMin":"styles_colMin__2p-PN","colCheckbox":"styles_colCheckbox__vmwKK"};